// extracted by mini-css-extract-plugin
export default {"noImage":"pYXGO","landscape":"dgtO3","portrait":"AuRR2","image":"mrvc_"};